import { TextEditor } from "../../../../shared/components/Editors";
import { ImportTemplateListResponse } from "../../../../shared/entities/ImportTemplateListResponse";
import { TranslationService } from "../../../../../services/TranslationService";
import { UpdateModelFunc } from "../ImportTemplateEditBase";
import EditItem from "./EditItem";

const SeparatorSimple = ({
  data,
  updateModel
}: {
  data?: ImportTemplateListResponse.Item;
  updateModel: UpdateModelFunc;
}) => {
  const { translate } = TranslationService;
  return (
    <>
      <EditItem label={<>{translate.Separator}</>}>
        <div className="row">
          <div className="col-6">
            <TextEditor
              onChange={updateModel("Separator")}
              defaultValue={data?.Separator}
              maxLength={1}
              onFocus={(e) => e.target.select()}
            />
          </div>
          <div className="col-6 col-form-label">Tab = "T"</div>
        </div>
      </EditItem>
    </>
  );
};

export default SeparatorSimple;
